import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useAlert } from 'react-alert';
import { useLoading } from '../../commons/Loading';
import {
  BtnOutlineRed,
  BtnOutlineGreen,
  BtnModalTable,
} from '../../styled-components';
import './InsurancesByMonth.scss';
import axios from 'axios';
import { useAuth } from '../../commons/Auth';
import PanoramicaInsuranceTabel from './PanoramicaInsuranceTabel';

const MAX_FILE_SIZE_MB = 1; // 1 MB
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024; // B

const ModalPanoramicaInsurance = (props) => {
  const {
    data = [],
    month,
    value,
    year,
    fetchTotalInsurances = () => {},
  } = props;
  const [t] = useTranslation('ROYALTY');
  const [{ newToken, profile = {} } = {}] = useAuth();
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();

  const [modal, setModal] = useState(false);
  const [insurances, setInsurances] = useState([]);
  const [insurancesPreview, setInsurancesPreview] = useState([]);
  const [seeButton, setSeeButton] = useState(true);
  const toggle = () => {
    if (modal) {
      setInsurancesPreview([]);
    }
    setModal(!modal);
  };

  const CURRENT_YEAR = new Date().getFullYear();
  const CURRENT_MONTH = new Date().getMonth() + 1;
  const getColor = ({ month, value, year }) => {
    const notNull = value !== null;
    if (notNull || year > CURRENT_YEAR) return '';

    const noInsurancesMonths = data.noInsuranceMonths;
    const noInsurance = noInsurancesMonths.filter((noInsuranceMonth) => {
      if (noInsuranceMonth.month === month && noInsuranceMonth.year === year) {
        return noInsuranceMonth;
      }
    });
    if (noInsurance.length > 0) return '';

    if (year < CURRENT_YEAR) return notNull ? '' : 'red';
    if (month < CURRENT_MONTH) return notNull ? '' : 'red';
    return '';
  };

  const confirmPreview = async () => {
    showLoading();
    const selectedInsurances = insurances.map((elem) => String(elem._id));
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/panoramica-invoices/${data.profileId}/invoices-by-admin`,
      {
        selectedInsurances,
        month,
        year,
      },
      {
        headers: { Authorization: newToken },
      }
    );
    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    alert.success(t('COMMON:SUCCESS_UPDATE'));

    setInsurances([]);
    setSeeButton(false);
    toggle();
    fetchTotalInsurances();
  };

  const listenForEscapeEvent = () => {
    document.addEventListener('keydown', ({ key }) => {
      if (key === 'Escape') toggle();
    });
  };

  const [totExtraGross, setTotExtraGross] = useState(0);
  let totalExtraGross = 0;
  const fetchInsurances = async () => {
    showLoading();
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/insurances-by-month-panoramica/${data.profileId}`,
      {
        headers: { Authorization: newToken },
        params: { month, year },
      }
    );

    if (response instanceof Error) {
      hideLoading();
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    for (const insurance of response.data) {
      totalExtraGross = totalExtraGross + insurance?.shareToInvoice;
    }
    setTotExtraGross(totalExtraGross.toFixed(2));
    setInsurances(
      response.data.map((item) => {
        return { ...item, extraGross: item?.shareToInvoice || 0 };
      })
    );
    hideLoading();
  };

  return (
    <React.Fragment>
      <span
        style={{
          color: getColor({ month, value, year }),
          cursor: 'pointer',
        }}
      >
        <span>Totale Assicurazioni: {value || 0}</span>
        <br />
        <br />
        <span>
          Totale Assicurazioni Da Rendicontare:{' '}
          {data.months[month - 1].invoicesToBeReported || 0}
        </span>
        <br />
        <br />
        <span>
          Totale Da Rendicontare: {data.months[month - 1].totalExtraGross || 0}{' '}
          €
        </span>
        <br />
        <br />
        {data?.months[month - 1]?.seeModal === true &&
          seeButton === true &&
          !profile._id && (
            <div className="flex-check">
              <BtnModalTable
                type="button"
                onClick={(event) => {
                  event.stopPropagation();
                  toggle();
                  fetchInsurances();
                }}
              >
                RENDICONTA
              </BtnModalTable>
            </div>
          )}
      </span>

      <Modal
        isOpen={modal}
        className="new-insurance-modal"
        onOpened={listenForEscapeEvent}
      >
        <ModalHeader toggle={toggle}>
          Anteprima Assicurazioni da Rendicontare
          <br />
        </ModalHeader>
        <ModalBody>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h5 style={{ fontFamily: "'Open Sans', sans-serif" }}>
              Totale da rendicontare: € {totExtraGross}
            </h5>
            <h5 style={{ fontFamily: "'Open Sans', sans-serif" }}>
              Assicurazioni da Rendicontare: {insurances.length}
            </h5>
          </div>
          {insurances.length > 0 ? (
            <PanoramicaInsuranceTabel
              data={insurances}
              onFilter={() => {}}
              query={{
                limit: insurances.length,
                offset: 0,
              }}
              total={insurances.length}
            />
          ) : (
            <div style={{ textAlign: 'center' }}>
              {' '}
              Non ci sono assicurazioni da rendicontare{' '}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <BtnOutlineRed type="button" className="uppercase" onClick={toggle}>
            {t('COMMON:CANCEL')}
          </BtnOutlineRed>
          {insurances.length > 0 && (
            <BtnOutlineGreen
              type="button"
              className="uppercase"
              onClick={confirmPreview}
            >
              Conferma Rendicontazione
            </BtnOutlineGreen>
          )}
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default ModalPanoramicaInsurance;
